import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { DfSelectSingleFilter } from '../../../shared/_directives/df-select-single/df-select-single-filter.model';
import { ReturnReviewStep } from './efile-workflow.service';
import {
  ReturnReviewDashboardRow,
  mapStepsToDashboardRows,
} from './return-review-dashboard.model';

@Component({
  selector: 'gtw-efile-return-review-dashboard',
  templateUrl: './efile-return-review-dashboard.component.html',
  styleUrls: ['./efile-return-review-dashboard.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EfileReturnReviewDashboardComponent {
  @Input() steps: ReturnReviewStep[] = [];
  @Input() loading = false;
  @Input() refreshing = false;
  @Input() loadError: string | null = null;
  @Input() exporting = false;
  @Input() irsFilter: DfSelectSingleFilter | null = null;
  @Input() irsFilterLoading = false;
  /** False while the newest IRS row is auto-selected (show "IRS Submissions" label). */
  @Input() irsFilterUserPicked = false;

  @Output() exportRequested = new EventEmitter<void>();
  @Output() refreshRequested = new EventEmitter<void>();
  @Output() irsFilterChange = new EventEmitter<DfSelectSingleFilter>();
  @Output() irsFilterReload = new EventEmitter<void>();
  @Output() rowSelected = new EventEmitter<ReturnReviewStep>();

  get rows(): ReturnReviewDashboardRow[] {
    return mapStepsToDashboardRows(this.steps);
  }

  trackByStep(_index: number, row: ReturnReviewDashboardRow): string {
    return `${row.step.WORKFLOW_STEP_ID}`;
  }

  onRowClick(row: ReturnReviewDashboardRow): void {
    this.rowSelected.emit(row.step);
  }

  onRowKeydown(event: KeyboardEvent, row: ReturnReviewDashboardRow): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.onRowClick(row);
    }
  }
}
